export const getDomainNameHeaderValue = () => {
  if (typeof window === "undefined") {
    return ""
  }

  let domain = window.location.hostname
  if (
    domain === "localhost" ||
    domain === "dev.vienvu.com" ||
    domain === "127.0.0.1"
  ) {
    // domain = "app.nhakhoadrchau.com"
    domain = "hpi.gratisoft.tech"
    // domain = "erp.dnacare.com.vn"
  }
  return domain
}
